import { render, staticRenderFns } from "./ball.vue?vue&type=template&id=95c1dc5e&"
import script from "./ball.vue?vue&type=script&lang=js&"
export * from "./ball.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports